import api from '../services/api';

export interface AuditLog {
  id: number;
  user_id: number | null;
  user_name: string;
  user_email: string;
  user_role: string;
  action: string;
  module: string;
  entity_type: string;
  entity_id: string;
  entity_label: string | null;
  field_name: string | null;
  old_value: string | null;   // JSON-encoded string
  new_value: string | null;   // JSON-encoded string
  summary: string | null;
  company_id: number;
  ip_address: string | null;
  created_at: string;
}

export interface AuditLogFilters {
  module?: string;
  entity_type?: string;
  entity_id?: string;
  action?: string;
  user_id?: number;
  from_date?: string;
  to_date?: string;
  q?: string;
  page?: number;
  pageSize?: number;
}

export interface AuditLogPage {
  data: AuditLog[];
  total: number;
  page: number;
  pageSize: number;
}

export interface AuditSummaryItem {
  module: string;
  action: string;
  count: number;
}

export const AUDIT_MODULES = [
  { value: 'designs',              label: 'Designs' },
  { value: 'workers',              label: 'Workers' },
  { value: 'worker-assignments',   label: 'Worker Assignments' },
  { value: 'design-cutting',       label: 'Design Cutting' },
  { value: 'job-works',            label: 'Job Works' },
  { value: 'purchase-orders',      label: 'Purchase Orders' },
  { value: 'vendors',              label: 'Vendors' },
  { value: 'purchases',            label: 'Purchases' },
  { value: 'expenses',             label: 'Expenses' },
  { value: 'dispatch',             label: 'Dispatch' },
  { value: 'design-materials',     label: 'Design Materials' },
  { value: 'dupatta-tracker',      label: 'Dupatta Tracker' },
  { value: 'inventory-adjustments','label': 'Inventory Adjustments' },
];

export const AUDIT_ACTIONS = [
  { value: 'CREATED',        label: 'Created' },
  { value: 'UPDATED',        label: 'Updated' },
  { value: 'DELETED',        label: 'Deleted' },
  { value: 'STATUS_CHANGED', label: 'Status Changed' },
  { value: 'ASSIGNED',       label: 'Assigned' },
  { value: 'RECEIVED',       label: 'Received' },
  { value: 'BULK_CREATED',   label: 'Bulk Created' },
  { value: 'CANCELLED',      label: 'Cancelled' },
  { value: 'COMPLETED',      label: 'Completed' },
  { value: 'PROCESSED',      label: 'Processed' },
];

export const auditLogsApi = {
  getAll: (filters: AuditLogFilters = {}) =>
    api.get<AuditLogPage>('/audit-logs', { params: filters }).then(r => r.data),

  getForEntity: (entityType: string, entityId: string | number) =>
    api.get<AuditLog[]>(`/audit-logs/entity/${entityType}/${entityId}`).then(r => r.data),

  getSummary: (filters: { from_date?: string; to_date?: string } = {}) =>
    api.get<AuditSummaryItem[]>('/audit-logs/summary', { params: filters }).then(r => r.data),
};
